import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import NoticeList from "./NoticeList";

import config from "./config";

export default class Notice extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      mode: null,
      taskId: null,
    };
  }

  componentDidMount() {
    this.initRouteState();
    this.renderButtons();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.urlParam1 !== this.props.urlParam1) {
      this.initRouteState();
    }
    this.renderButtons();
  }

  renderButtons = () => {
    this.context.actionsSet(<></>);
  };

  initRouteState = () => {
    const param = this.props.urlParam1;
    this.setState({ taskId: null, mode: param });
  };

  renderNav() {
    let nav = {
      current: "Все новые",
      interfere: "Только требующие реакции",
      archive: "Архив",
    };
    const notifierValues = this.context.notifier.notice || {};
    let pills = {
      current: notifierValues[config.CATEGORY_ALL] ? (
        <span className="label label-light ml-2">
          {notifierValues[config.CATEGORY_ALL]}
        </span>
      ) : null,
      interfere: notifierValues[config.CATEGORY_INTERFERE] ? (
        <span className="label label-warning ml-2">
          {notifierValues[config.CATEGORY_INTERFERE]}
        </span>
      ) : null,
    };
    return (
      <ul className="nav nav-tabs">
        {Object.entries(nav).map(([id, title]) => (
          <li className="nav-item w-lg-auto w-100" key={id}>
            <Link
              to={`/notice/${id}/`}
              className={` ${
                this.state.mode === id ? "active" : ""
              } cursor-pointer nav-link`}
            >
              {title}
              {pills[id]}
            </Link>
          </li>
        ))}
      </ul>
    );
  }

  render() {
    return (
      <>
        <CrumbsProvider title="Уведомления" />
        <div className="container">
          {this.renderNav()}
          <NoticeList mode={this.state.mode} />
        </div>
        <br />
      </>
    );
  }
}
